import React, { useEffect } from 'react';

import { useSelector } from 'react-redux';
import * as FSaver from 'file-saver';
import * as XLSX from 'xlsx';

const mapStateToProps = (state) => {
    const {
        api: {
            geoObjReportExcel,
        } = {},
    } = state;
    return {
        geoObjReportExcel,
    }
}

const XlsxSaver = () => {
    const {
        geoObjReportExcel
    } = useSelector(mapStateToProps)
    useEffect(()=>{
        if(geoObjReportExcel && geoObjReportExcel.data && !geoObjReportExcel.loading){
            const { data } = geoObjReportExcel
            const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            const fileExtension = 'xlsx';
            const fileName='Report';
            const workbook = XLSX.utils.book_new();
            const worksheet = XLSX.utils.aoa_to_sheet(data);
            XLSX.utils.book_append_sheet(workbook, worksheet, "Отчет", true);
            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            const sData = new Blob([excelBuffer], {type: fileType});
            FSaver.saveAs(sData, `${fileName}_${(new Date()).toDateString()}.${fileExtension}`);
        }
    },[geoObjReportExcel])
    return null
}

export default XlsxSaver